'use strict';

var NewExtractOutputSubpanelDirective = function NewExtractOutputSubpanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-extract-output-subpanel.html'),
    requires: '^rmDataExtractNewExtract'
  };
};
NewExtractOutputSubpanelDirective.$inject = [];
module.exports = NewExtractOutputSubpanelDirective;